import React from 'react';
import useSearch from '../../../context/search/useSearch';

interface SearchTabsProps {
  dataSet: DOMStringMap;
}

const SearchTabs: React.FC<SearchTabsProps> = () => {
  const { activeTab, setActiveTab, productSearchResult, searchResultsArticles, searchResultsPages } = useSearch();

  // Only show counts when results are finalized (not null means they've been fetched)
  // null = not loaded yet, array = loaded (even if empty)
  const productsLoaded = productSearchResult !== null;
  const articlesLoaded = searchResultsArticles !== null;
  const pagesLoaded = searchResultsPages !== null;

  const productCount = productSearchResult?.total ?? 0;
  const articleCount = searchResultsArticles?.length ?? 0;
  const pageCount = searchResultsPages?.length ?? 0;


  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId)
  }

  const tabs = [
    { id: 'products', label: 'Products', count: productCount, showCount: productsLoaded },
    { id: 'blogs', label: 'NFD Edit', count: articleCount, showCount: articlesLoaded },
    { id: 'pages', label: 'Pages', count: pageCount, showCount: pagesLoaded }
  ];

  const searchViewSwitcher: HTMLElement | null = document.querySelector('.search-view-switcher');
  const searchFiltersButton: HTMLElement | null = document.querySelector('.filter-and-sort__btn');

  if (activeTab !== 'products' || productCount === 0) {
    if (searchViewSwitcher) searchViewSwitcher.style.display = 'none';
    if (searchFiltersButton) searchFiltersButton.style.display = 'none';
  } else {
    if (searchViewSwitcher) searchViewSwitcher.style.display = 'flex';
    if (searchFiltersButton) searchFiltersButton.style.display = 'flex';
  }

  return (
    <div className="search-tabs">
      <div className="search-tabs__container">
        <nav className="search-tabs__nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`search-tabs__tab ${activeTab === tab.id ? 'search-tabs__tab--active' : ''}`}
              role="tab"
              aria-selected={activeTab === tab.id}
              onClick={() => handleTabClick(tab.id)}
            >
              <span>{tab.label}{tab.showCount ? ` (${tab.count})` : ''}</span>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default SearchTabs;
